// Katakana (U+30A1 - U+30F6) -> Shift-JIS (0x8340 - 0x8396)
export const KATAKANA_START = 0x30a1;
